import { ReactElement, isValidElement } from "react";

import { DigitalJourneyFlowPage } from "./DigitalJourneyFlowPage";
import { DigitalJourneyAppFlowJSX, DigitalJourneyFlowPages, PageProps } from "./types";

export const getDigitalJourneyFlowPages = (node: DigitalJourneyAppFlowJSX): ReactElement<PageProps>[] => {
  const nodes = Array.isArray(node) ? node : [node];

  return nodes.reduce<DigitalJourneyFlowPages>((allPages, child) => {
    let pagesAndSubPages: DigitalJourneyFlowPages = [];

    if (child && child.props.children) {
      pagesAndSubPages = getDigitalJourneyFlowPages(child.props.children);
    }

    if (isValidElement(child) && child.type === DigitalJourneyFlowPage) {
      pagesAndSubPages.push(child);
    }

    return [...allPages, ...pagesAndSubPages];
  }, []) as ReactElement<PageProps>[];
};
